export default __webpack_public_path__ + "static/loading_view.gif?v=1c32f2f561e4ed53bf9b1376c5601ffd";